import { render, staticRenderFns } from "./EditFrontDesk.vue?vue&type=template&id=151b2057&scoped=true"
import script from "./EditFrontDesk.vue?vue&type=script&lang=js"
export * from "./EditFrontDesk.vue?vue&type=script&lang=js"
import style0 from "./EditFrontDesk.vue?vue&type=style&index=0&id=151b2057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b2057",
  null
  
)

export default component.exports